module.exports = __webpack_public_path__ + "img/antes_despues_307.78c77b1f.png";